import { useSelector } from "react-redux";
import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useSentPaginatedTasks = ({ search, page, rows = 10 }) => {

    const tenantVal =
        useSelector((state) => state.auth.user?.tenant) ||
        localStorage.getItem("kinesin-tenant");

    return useQuery({
        queryKey: ["sentPaginatedTasks", search, page, rows, tenantVal],
        queryFn: async () => {
            const axiosInstance = await createAxiosInstance();
            const response = await axiosInstance.get(`${tenantVal}/task/getmytaskcreatedby/page?page=${page}&rows=${rows}`);

            return response.data;
        },
        enabled: !!tenantVal,
    meta: { errorMessage: "Error fetching sent tasks" },
   
        staleTime: 1000 * 60 * 5,
        refetchOnWindowFocus: true,
    });
};
